<template>
  <div>
    <ts-loading-banner :loading="loadingPreData">
      <form class="form-horizontal mt-3">
        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-7">
                <fieldset>
                  <legend class="text-black">
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.studentProfile.managementDiscount'
                      )
                    }}
                  </legend>
                  <div>
                    <div class="row form-group">
                      <div class="col-md-6">
                        <div class="row">
                          <label class="col-md-12 col-form-label" style="text-align: left;">
                            {{ $t('school.academic.operation.profile_mgt.studentProfile.mainProgram') }}
                          </label>
                          <div class="col-md-12">
                            <a-select style="width: 100%" v-model="acp_id" :options="mainProgramsOptions"
                              :show-search="true" :maxTagCount="2" :placeholder="$t('all')" mode="multiple"
                              :filter-option="(input, option) =>
                                option.componentOptions.children[0].text
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                                "></a-select>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="row">
                          <label class="col-md-12 col-form-label" style="text-align: left;">
                            {{ $t('school.academic.operation.profile_mgt.studentProfile.subProgram') }}
                          </label>
                          <div class="col-md-12">
                            <a-select style="width: 100%" v-model="acps_id" :options="subProgramsOptions"
                              :show-search="true" :maxTagCount="1" :placeholder="$t('all')" mode="multiple"
                              :filter-option="(input, option) =>
                                option.componentOptions.children[0].text
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                                " @change="onChangeAcps"></a-select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row form-group">
                      <div class="col-md-12">
                        <div class="table-ui-detail">
                          <table class="ts-w-full">
                            <thead>
                              <tr>
                                <th style="width: 25%">
                                  {{ $t("school.academic.operation.profile_mgt.studentProfile.subProgram") }}
                                  <span class="ts-text-red-600">*</span>
                                </th>
                                <th style="width: 20%">
                                  {{ $t("school.academic.operation.profile_mgt.studentProfile.discountRate") }}
                                  <span class="ts-text-red-600">*</span>
                                </th>
                                <th style="width: 15%">
                                  {{ $t("school.academic.operation.profile_mgt.studentProfile.untilFurtherNotice") }}
                                  <span class="ts-text-red-600">*</span>
                                </th>
                                <th style="width: 20%">
                                  {{ $t("school.academic.operation.profile_mgt.studentProfile.discountExpiryDate") }}
                                  <span class="ts-text-red-600">*</span>
                                </th>
                                <th style="width: 20%">
                                  {{ $t("school.academic.operation.profile_mgt.studentProfile.discountNote") }}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-if="model.discount_by_sub_programs == 0">
                                <td colspan="5" class="ts-text-center ts-p-3 ts-space-x-1">
                                  <i class="fa fa-folder-open ts-text-gray-200"></i>
                                  <label class="ts-text-gray-400">
                                    {{ $t('noData') }}
                                  </label>
                                  <div class="validate ts-text-left" v-if="errors.has('product_list')">
                                    {{ errors.first('product_list') }}
                                  </div>
                                </td>
                              </tr>
                              <tr v-for="(item, index) in model.discount_by_sub_programs" :key="index">
                                <td>
                                  {{ getSubProgramName(item.acps_id) }}
                                </td>
                                <td>
                                  <input type="number" v-model.number="item.card_discount_rate"
                                    class="form-control only-border-bottom" :class="{
                                      'is-invalid': errors.has(
                                        'discount_by_sub_programs.' +
                                        index +
                                        '.card_discount_rate'
                                      ) || $v.model.discount_by_sub_programs.$each[index].card_discount_rate.$error
                                    }" />
                                </td>
                                <td class="ts-text-center">
                                  <a-checkbox v-model="item.is_till_further_notice"
                                    @change="() => onChangeUntilFurtherNotice(item)"></a-checkbox>
                                </td>
                                <td>
                                  <a-date-picker v-model="item.discount_expiry_date" format="DD-MM-YYYY"
                                    valueFormat="DD-MM-YYYY" class="ts-w-full" :disabled="item.is_till_further_notice"
                                    :class="{
                                      'is-invalid': errors.has(
                                        'discount_by_sub_programs.' +
                                        index +
                                        '.discount_expiry_date'
                                      ) || $v.model.discount_by_sub_programs.$each[index].discount_expiry_date.$error
                                    }"></a-date-picker>
                                </td>
                                <td>
                                  <textarea v-model.number="item.discount_note" rows="1"
                                    class="form-control only-border-bottom" :class="{
                                      'is-invalid': errors.has(
                                        'discount_by_sub_programs.' +
                                        index +
                                        '.discount_note'
                                      )
                                    }" style="height: 35px;" />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>
              <div class="col-md-5">
                <fieldset>
                  <legend class="text-black">
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.studentProfile.corporateDiscount'
                      )
                    }}
                  </legend>
                  <div class="row form-group">
                    <label class="col-md-3 col-form-label">
                      {{
                        $t(
                          'school.academic.operation.profile_mgt.studentProfile.corporatePartner'
                        )
                      }}
                    </label>
                    <div class="col-md-8">
                      <ts-search-select v-model.number="model.cpp_id"
                        :options="corporatePartnerOptions"></ts-search-select>
                      <div v-if="errors.has('cpp_id')" class="validate">
                        {{ errors.first('cpp_id') }}
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>
            </div>
          </div>
          <div class="col-md-3"></div>
        </div>
      </form>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { required, requiredIf } from 'vuelidate/lib/validators'
import { includes } from 'lodash'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'discount-form',
  props: ['value', 'validate', 'clear'],
  data() {
    return {
      model: {},
      loadingPreData: false,
      mainPrograms: [],
      subPrograms: [],
      acp_id: [],
      acps_id: [],
      errors: new Errors()
    }
  },
  async created() {
    this.getMainProgram().then((response) => {
      this.mainPrograms = response.data
    })
    this.getSubProgram().then((response) => {
      this.subPrograms = response.data
    })
    await Promise.all([this.fetchCorporatePartner()]).then(() => {
      this.model = this.value
      this.setEditData()
    })
  },
  validations: {
    model: {
      discount_by_sub_programs: {
        $each: {
          acps_id: { required },
          student_id: { required },
          card_discount_rate: { required },
          is_till_further_notice: { required },
          discount_expiry_date: {
            required: requiredIf((item) => !item.is_till_further_notice)
          },
        },
      },
    },
  },
  computed: {
    ...mapState('studentProfile', ['coperatePathners', 'edit_data']),
    corporatePartnerOptions() {
      return this.coperatePathners.map(el => ({
        value: el.cpp_id,
        text: el.partner_name_en + '|' + el.partner_name_kh
      }))
    },
    mainProgramsOptions() {
      return this.mainPrograms.map(el => ({
        value: el.acp_id,
        label: el.acp_name_foreign
      }))
    },
    subProgramsOptions() {
      if (this.acp_id.length > 0) {
        return this.subPrograms
          .filter(el => includes(this.acp_id, el.acp_id))
          .map(el => ({
            value: el.acps_id,
            label: el.acps_name_foreign
          }))
      }
      return this.subPrograms
        .map(el => ({
          value: el.acps_id,
          label: el.acps_name_foreign
        }))
    }
  },
  methods: {
    ...mapActions('studentProfile', ['fetchCorporatePartner', 'getMainProgram', 'getSubProgram']),
    validateForm() {
      this.$v.$touch()
      const $invalid = this.$v.model.discount_by_sub_programs.$invalid
      return !$invalid
    },
    getSubProgramName(acps_id) {
      if (acps_id) {
        return this.subPrograms.find(el => el.acps_id == acps_id) ? this.subPrograms.find(el => el.acps_id == acps_id).acps_name_foreign : ''
      }
      return ''
    },
    onChangeUntilFurtherNotice(item) {
      if (item.is_till_further_notice) {
        item.discount_expiry_date = ''
      }
    },
    onChangeAcps(value) {
      this.model.discount_by_sub_programs = [];

      this.acps_id.forEach(el => {
        let item = {
          student_id: this.model.student_id,
          acps_id: el,
          card_discount_rate: null,
          is_till_further_notice: false,
          discount_expiry_date: null,
          discount_note: null,
        };

        if (!_.isEmpty(this.edit_data)) {
          item = this.edit_data.discount_by_sub_programs.find(ed => ed.acps_id == el) ? this.edit_data.discount_by_sub_programs.find(ed => ed.acps_id == el) : item;
        }

        this.model.discount_by_sub_programs.push(item);
      });
    },
    setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        this.acps_id = this.edit_data.discount_by_sub_programs.map(el => el.acps_id)
        this.model.student_id = this.edit_data.student_id
        this.model.is_card_discount = this.edit_data.is_card_discount
        this.model.is_till_further_notice = this.edit_data.is_till_further_notice
        this.model.card_discount_rate = this.edit_data.card_discount_rate
        this.model.discount_expiry_date = this.edit_data.discount_expiry_date
        this.model.discount_note = this.edit_data.discount_note
        this.model.cpp_id = this.edit_data.cpp_id
        this.model.discount_by_sub_programs = this.edit_data.discount_by_sub_programs
      }
    }
  },
  watch: {
    validate: {
      handler() {
        this.errors = new Errors(this.validate.errors)
      },
      deep: true
    },
    'model.is_card_discount': function (isCardDiscount) {
      if (!isCardDiscount) {
        this.model.is_till_further_notice = false
        this.model.card_discount_rate = ''
        this.model.discount_expiry_date = ''
        this.model.discount_note = ''
      }
    },
    'model.is_till_further_notice': function (isTillFurtherNotice) {
      if (this.model.is_card_discount && isTillFurtherNotice) {
        this.model.discount_expiry_date = ''
      }
    },
    clear: function (value) {
      if (value == true) {
        this.model = this.value
      }
    }
  }
}
</script>
<style scoped>
.table-ui-detail table {
  font-family: Consolas, Hanuman, Courier, monospace;
  font-size: 12px;
  border-collapse: collapse;
  border-spacing: 0;
  empty-cells: show;
  border: 1px solid #e9e9e9;
  width: 100%;
}

.table-ui-detail table th {
  background: #f7f7f7;
  white-space: nowrap;
  color: #5c6b77;
  font-weight: 600;
  padding: 4px 6px;
  top: 0;
  position: sticky;
  z-index: 5;
}

.table-ui-detail table td {
  border: 1px solid #e9e9e9;
  padding: 3px 5px;
}

.table-ui-detail table td .form-check .form-check-input {
  float: right;
  margin-left: -2em;
}
</style>
<style>
.is-invalid .ant-calendar-picker-input {
  border: 1px solid red !important;
}

.is-invalid .ant-calendar-picker-icon {
  color: red !important;
}
</style>